import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

const seenNotifications = new Set()

export default class extends Controller {
    static values = {
        title: String,
        text: String,
        confirmText: { type: String, default: "OK" },
        url: String,
        ackUrl: String,
        notificationKey: String
    }

    connect() {
        if (this.notificationKeyValue) {
            const key = `ai-invitation-ready:${this.notificationKeyValue}`
            let seen = seenNotifications.has(key)
            try { seen ||= window.sessionStorage.getItem(key) === "1" } catch (_) {}
            if (seen) {
                this.element.remove()
                return
            }
            seenNotifications.add(key)
            try { window.sessionStorage.setItem(key, "1") } catch (_) {}
        }

        Swal.fire({
            title: this.titleValue,
            text: this.textValue,
            icon: "success",
            confirmButtonText: this.confirmTextValue,
            customClass: {
                confirmButton: "btn blue-button" //
            },
            buttonsStyling: false
        }).then(result => {
            if (result.isConfirmed) {
                if (this.hasAckUrlValue) {
                    fetch(this.ackUrlValue, {
                        method: "POST",
                        keepalive: true,
                        headers: {
                            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
                            "Accept": "text/vnd.turbo-stream.html"
                        }
                    }).catch(() => {
                    });
                }
                if (this.urlValue) {
                    window.location.assign(this.urlValue)
                }
            }

            // Clean up so it doesn’t retrigger on Turbo visits
            this.element.remove()
        })
    }
}
